const INITIAL_STATES = {
  status: false
};

export default function (state = INITIAL_STATES, action) {
  switch (action.type) {
    case 'CHANGE_STATUS':
      return {
        ...state,
        status: action.payload,
      };

    default:
      return state;
  }
}
